import { generateResourceReducer } from '../generators/resource.reducer';

import * as types from './conclusion.types';
import * as constants from './conclusion.constants';

export const conclusionReducer = generateResourceReducer<types.IConclusion>({
  STORE: constants.STORE_CONCLUSION,
  CLEAR: constants.CLEAR_CONCLUSION,
});
